module.exports = __webpack_public_path__ + "static/media/icon_location.a9eba83a.svg";